"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _helpers = require("../helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Enum = ({
  value,
  format,
  fetched,
  fetching,
  schema
}) => {
  if (!fetched) return /*#__PURE__*/_react.default.createElement("span", {
    className: 'component-string-placeholder' + (fetching ? ' fetching' : ''),
    style: {
      width: `${(0, _helpers.getRandomInt)(8, 10)}em`
    }
  });
  if (!value) return /*#__PURE__*/_react.default.createElement("span", {
    className: 'component-string-placeholder' + (fetching ? ' fetching' : ''),
    style: {
      width: `${(0, _helpers.getRandomInt)(8, 10)}em`
    }
  });
  return /*#__PURE__*/_react.default.createElement("span", null, schema.options[value]);
};
var _default = exports.default = Enum;
module.exports = exports.default;